import Doek from './classes/doekclass.js';
import LinkShape from './classes/linkshape.js';

document.addEventListener('DOMContentLoaded', function() {

    // Functie om de query parameters uit de URL te halen
    function getQueryParams() {
        var params = {};
        var queryString = window.location.search.substring(1);
        var queries = queryString.split("&");
        for (var i = 0; i < queries.length; i++) {
            var pair = queries[i].split("=");
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    }
    
    // Haal de waarde van 'popup' uit de query parameters
    var queryParams = getQueryParams();
    var popupName = queryParams['popup'];
    
    if (popupName) {
        showPopup(popupName);
    }
});